import {BaseItem} from './index';

export interface User extends BaseItem {
  name: {
    firstName: string;
    middleName?: string;
    lastName: string;
  };
  personalNumber: string;
  userName: string;
  group: UserGroup;
  avatar?: string;
  jobRoleId?: string;
  approvedConditions?: {
    termsAndConditions?: {
      approvedAt: string;
    };
    globalTermsAndConditions?: {
      approvedAt: string;
    };
    globalPrivacyPolicy?: {
      approvedAt: string;
    };
  };
}

export interface AuthorizedRelative extends User {
  group: UserGroup.AuthorizedRelatives;
  email: string;
  phoneNumber?: string;
  residentsId: string[];
  address?: {
    country: string;
    city: string;
    street: string;
    zipCode: string;
  };
}

export type CreateUserInput = {
  name: {
    firstName: string;
    middleName?: string;
    lastName: string;
  };
  personalNumber: string;
  group: UserGroup;
  jobRoleId?: string;
};

export type CreateAuthorizedRelativeUserInput = {
  name: {
    firstName: string;
    middleName?: string;
    lastName: string;
  };
  email: string;
  phoneNumber?: string;
  residentId: string;
  address?: {
    country: string;
    city: string;
    street: string;
    zipCode: string;
  };
};

export enum UserGroup {
  Superusers = 'superusers',
  Owners = 'owners',
  Admins = 'admins',
  Employees = 'employees',
  Moderators = 'moderators',
  EmployeesInventory = 'employees_inventory',
  AuthorizedRelatives = 'authorized_relatives',
}

export type UserUpdate = {
  userName: string;
  name: {
    firstName: string;
    middleName?: string;
    lastName: string;
  };
  group: UserGroup;
  jobRoleId?: string;
};

export type AuthorizedRelativeUserUpdate = {
  userName: string;
  name: {
    firstName: string;
    middleName?: string;
    lastName: string;
  };
  phoneNumber?: string | null;
  residentsId: string[];
  address?: {
    country: string;
    city: string;
    street: string;
    zipCode: string;
  } | null;
};

export type Identity = {
  sub: string;
  username: string;
  groups: UserGroup[];
};

export type GenerateTemporaryPasswordResponse = {
  userName: string;
  tempPassword: string;
};

export type UserApproveConditionsInput = {
  termsAndConditions: {
    approvedAt: string;
  };
};
